<template>
  <svg :width="width" :height="height" viewBox="0 0 21 23" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.76268 17.4222L15.4296 10.8866C16.1556 10.1606 16.5635 9.17592 16.5635 8.1492C16.5635 7.12248 16.1556 6.13781 15.4296 5.41181C14.7036 4.68581 13.719 4.27795 12.6922 4.27795C11.6655 4.27795 10.6808 4.68581 9.95485 5.41181L2.61398 12.7535C1.58057 13.7869 1 15.1886 1 16.65C1 18.1115 1.58057 19.5131 2.61398 20.5465C3.6474 21.5799 5.04901 22.1605 6.51048 22.1605C7.97195 22.1605 9.37356 21.5799 10.407 20.5465L17.7478 13.2053C19.0887 11.8645 19.8419 10.0459 19.8419 8.1497C19.8419 6.25348 19.0887 4.43493 17.7478 3.0941C16.407 1.75327 14.5885 1 12.6922 1C10.796 1 8.97747 1.75327 7.63664 3.0941L1.03561 9.69566" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
import {colors} from "../../constants";

export default {
  props: {
    width: { type: [Number, String], default: 16 },
    height: { type: [Number, String], default: 14 },
    color: { type: String, default: colors.backgroundGrey }
  },
  name: "IconPaperclip"
}
</script>

<style scoped>
  svg{
      fill: var(--icon-svg);
  }
  path{
      stroke: var(--icon-path);
  }
</style>